import { Analysis, AnalysisVisualizationConfig, AnalysisORM, useAnalysis } from "@models/analysis";
import { ReportBuilderDimension, ReportBuilderMeasure, useDimensions, useMeasures } from "@models/reportBuilder";
import { useCallback, useEffect, useMemo, useState } from "react";
import SmallCard from "../card/SmallCard.component";
import { AnalysisDisplay } from "./AnalysisDisplay.component";
import { getErrorMessage } from "@services/errors.service";
import Danger from "@components/statusIndicators/Danger.component";
import FullScreenTakeover from "@components/general/FullScreenTakeover.component";
import { AnalysisEditor } from "@pages/Analysis/AnalysisScreen.page";
import { useQueryClient } from "react-query";
import produce from "immer";



interface Props {
    analysisId: string;
    compact?: boolean;
    onExpand?: () => void;
    onCollapse?: () => void;
    autoRun?: boolean;
    visualizationConfig?: AnalysisVisualizationConfig;
}
const AnalysisRunner = (props: Props) => {
    
    const analysis = useAnalysis(props.analysisId);
    const queryClient = useQueryClient();

    const dimensions = useDimensions();
    const metrics = useMeasures();

    const [showAnalysis, setShowAnalysis] = useState(false);
    const [currentAnalysis, setCurrentAnalysis] = useState<Analysis | null>(null);
    const [currentVisualizationConfig, setCurrentVisualizationConfig] = useState<AnalysisVisualizationConfig | undefined>(undefined);

    const toggleSort = useCallback((entityType: string, entityId: string) => {
        if (!currentAnalysis) return;
        
        // It goes ASC -> DESC -> OFF
        const updatedAnalysis = produce(currentAnalysis, (draft) => {
            if (!draft.default_sort_order) {
                draft.default_sort_order = [];
            }
            const idx = draft.default_sort_order.findIndex(s => s.entity_id === entityId && s.entity_type === entityType);
            if (idx === -1) {
                draft.default_sort_order.push({
                    entity_id: entityId,
                    entity_type: entityType,
                    ascending: true,
                });
            } else if (draft.default_sort_order[idx].ascending) {
                draft.default_sort_order[idx].ascending = false;
            } else {
                draft.default_sort_order.splice(idx, 1);
            }
        });
        
        setCurrentAnalysis(updatedAnalysis);
        setCurrentVisualizationConfig(undefined);
    }, [currentAnalysis]);

    const removeSort = useCallback((entityType: string, entityId: string) => {
        if (!currentAnalysis) return;
        
        const updatedAnalysis = produce(currentAnalysis, (draft) => {
            if (!draft.default_sort_order) {
                return;
            }
            const idx = draft.default_sort_order.findIndex(s => s.entity_id === entityId && s.entity_type === entityType);
            if (idx !== -1) {
                draft.default_sort_order.splice(idx, 1);
            }
        });
        
        setCurrentAnalysis(updatedAnalysis);
        setCurrentVisualizationConfig(undefined);
    }, [currentAnalysis]);

    const runAnalysis = useCallback(() => {
        setShowAnalysis(false);
        setTimeout(() => {
            setShowAnalysis(true);
        }, 500)
        
    }, []);

    console.log('visualizationConfig in analysis runner', props.visualizationConfig);

    useEffect(() => {
        if (analysis.data) {
            setCurrentAnalysis(analysis.data);
            if (props.visualizationConfig) {
                setCurrentVisualizationConfig(props.visualizationConfig);
            }
        }
    }, [analysis.data, props.visualizationConfig]);

    useEffect(() => {
        if (props.autoRun && !!analysis.data) {
            runAnalysis();
        }
    }, [props.autoRun, analysis.dataUpdatedAt]);


    if (analysis.isLoading) {
        return <div>Loading...</div>
    }

    if (analysis.data) {
        return <div className={`d-flex flex-column w-100 flex-1`}>
            <div className="d-flex mb-3 w-100">
                <div  className="flex-1 ">
                    <div className="mb-2">
                        <h2 className="mb-0">{analysis.data.name}</h2>
                        <p>Chart Type: {analysis.data.visualization_type}</p>
                    </div>
                </div>
                <div  className="text-end">
                    <a href={`/charts/${props.analysisId}`} target="_blank" className="btn  btn-light me-1">
                        <i className="mdi mdi-pencil"></i> Edit
                    </a>
                    {/* {props.compact && <button className="btn  btn-secondary me-1" onClick={props.onExpand}>
                        View
                    </button>}
                    {!props.compact && <button className="btn  btn-secondary me-1" onClick={props.onCollapse}>
                        Hide
                    </button>} */}
                    <button className="btn  btn-primary" onClick={runAnalysis}>
                        <i className="mdi mdi-refresh"></i>
                    </button>
                </div>
            </div>
            
            {/* {!props.compact && false &&  !!analysis.data &&   <>
                <div className="row">
                    <div className="col-4">
                        <SmallCard title="Metrics">
                            <p className="font-13 text-muted">What are we measuring?</p>
                            <ul>
                                {analysis.data.measure_ids.map(m => {
                                    const metric = metricsById[m];
                                    if (!metric) {
                                        return <li key={m} className="text-danger">Unknown metric: {m}</li>
                                    } else {
                                        return <li key={m}>{metric.name}</li>
                                    }
                                })}
                            </ul>
                        </SmallCard>
                        
                    </div>
                    <div className="col-4">
                        <SmallCard title="Dimensions">
                            <p className="font-13 text-muted">What are we grouping by?</p>
                            <ul>
                                {analysis.data.dimension_ids.map(d => {
                                    const dimension = dimensionsById[d];
                                    if (!dimension) {   
                                        return <li key={d} className="text-danger">Unknown dimension: {d}</li>
                                    } else {
                                        return <li key={d}>{dimension.name}</li>
                                    }
                                })}
                            </ul>
                        </SmallCard>
                    </div>
                    <div className="col-4">
                        <SmallCard title="Filters">
                            <p className="font-13 text-muted">What are we filtering by?</p>
                            <div className="mb-2">
                                <h5>Date Range</h5>
                                {analysis.data.date_range == 'CUSTOM' && <>
                                    {analysis.data.custom_date_range_start} to {analysis.data.custom_date_range_end}
                                </>}
                                {analysis.data.date_range != 'CUSTOM' && <>
                                    {analysis.data.date_range || 'ALL_TIME'}
                                </>}
                            </div>
                            <div>
                                <h5>Other Filters</h5>
                                {analysis.data.dimension_filters && analysis.data.dimension_filters.length > 0 && <>
                                    <ul>
                                        {analysis.data.dimension_filters && analysis.data.dimension_filters.map(f => {
                                            const dimension = dimensionsById[f.dimension_id];
                                            if (!dimension) {
                                                return <li key={f.dimension_id} className="text-danger">Unknown dimension: {f.dimension_id}</li>
                                            } else {
                                                return <li key={f.dimension_id}>{dimension.name} {f.comparator} {f.value}</li>
                                            }
                                        })}
                                    </ul>
                                </>}
                                {!analysis.data.dimension_filters || analysis.data.dimension_filters.length === 0 && <p>No filters</p>}
                            </div>

                        </SmallCard>
                    </div>
                </div>
                </>} */}
                {showAnalysis && currentAnalysis && <div style={{minHeight: currentAnalysis.visualization_type == 'SINGLE_VALUE' ? '100px' : '400px'}}>
                    <AnalysisDisplay 
                        visualizationConfig={currentVisualizationConfig} 
                        analysis={currentAnalysis} 
                        removeSort={removeSort} 
                        toggleSort={toggleSort} 
                        onDrillDown={() => {}} 
                        showEmptyState={false} 
                    />
                </div>}
            
            
        </div>;
    }

    if (analysis.error) {
        return <div>
            <Danger>{getErrorMessage(analysis.error)}</Danger>
        </div>
    }
    return <div>
        <Danger>Something went wrong. Please try again.</Danger>
    </div>
}

export default AnalysisRunner;